import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import $$ from 'cmn-utils';
import config from '@/config';

class BaseComponent extends React.Component {
  /**
   * 在没有dispatch函数时，如果想要在组件内进行跳转可以用router进行跳转
   */
  static contextTypes = {
    router: PropTypes.object
  };

  notice = config.notice; // 消息通知

  /**
   * history api 路由跳转
   */
  get history() { 
    return this.context.router.history;
  }

  /**
   * 新增
   */
  onAdd = () => {
    this.setState({
      record: null,
      visible: true
    });
  };

  /**
   * 修改
   * @param {object} 表单记录
   */
  onUpdate = record => () => {
    this.setState({
      record,
      visible: true
    });
  };

  /**
   * 删除
   * @param {object | array} 表单记录, 批量删除时为数组
   */
  onDelete = record => () => {
    if (!record) return;    
    if ($$.isArray(record) && !record.length) return;

    const content = `${window.language['client.delTipStart']}${
      $$.isArray(record) ? record.length : ''
    }${window.language['client.delTipEnd']}`;

    Modal.confirm({
      className: 'custom-modal',
      title: window.language['client.notice'],
      okText:window.language['common.ok'],
      cancelText:window.language['common.cancel'],
      content,
      onOk: () => {
        this.handleDelete($$.isArray(record) ? record : [record]);
      },
      onCancel() {}
    });
  };

  /**
   * 删除,调用回调函数
   * @param {object | array} 表单记录, 批量删除时为数组
   */
  onDeleteWithFunction = (record, callback) => () => {    
    if (!record) return;    
    if ($$.isArray(record) && !record.length) {
      Modal.info({
        title: window.language['common.tip'],
        okText: window.language['common.close'],
        className: "custom-modal",        
        content: window.language['common.delTipContent'],
        onOk() {
        },
      });
      return;
    }
  
    const content = `${window.language['client.delTipStart']}${
      $$.isArray(record) ? record.length : ''
    }${window.language['client.delTipEnd']}`;

    Modal.confirm({
      className: 'custom-modal',
      title: window.language['client.notice'],
      okText:window.language['common.ok'],
      cancelText:window.language['common.cancel'],
      content,
      onOk: () => {
        //this.handleDelete($$.isArray(record) ? record : [record]);
        if(typeof callback === 'function'){
            callback($$.isArray(record) ? record : [record]);
        }
      },
      onCancel() {}
    });
  }

  handleAdd() {
    /* 子类重写 */
  }
  handleUpdate() {
    /* 子类重写 */
  }
  handleDelete() {
    /* 子类重写 */
  }  
}

export default BaseComponent;



// WEBPACK FOOTER //
// ./src/components/BaseComponent/index.js